import { AppState } from "../../../redux-configuration/AppState";
import { CartesianData } from "../../domain/entity/cartesianData";

export const retrieveCompanyStatsLoadingSelector = (state: AppState): boolean => state.stats.proAccount.loading
export const retrieveCompanyStatsErrorSelector = (state: AppState): string | undefined => state.stats.proAccount.error
export const companyVisitsStatsSelector = (state: AppState): CartesianData[] | undefined => state.stats.proAccount.visits
export const companyFollowersStatsSelector = (state: AppState): CartesianData[] | undefined => state.stats.proAccount.followers
